import React from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import logo from '../images/logo.png';


class Signup extends React.Component {
    constructor(props){
        super(props); 

        this.state = {
            username: '',
            email: '',
            password: '',
            roles: ['user', 'admin'],
            status: "active",
            emailValid: false,
            signUpMessage: '',
            isLoggedIn: true
        }

        this.handleUsername = this.handleUsername.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
    }

    componentDidMount() {
        if (this.props.userdata.isLoggedIn === false){
            this.setState({
                isLoggedIn: false
            }); 
        }
    }

    handleUsername = (event) => {
        this.setState({
            username: event.target.value
        })

    }

    handlePassword = (event) => {
        this.setState({
            password: event.target.value
        })
    }

    handleEmail = (event) => {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(event.target.value)) {
            this.setState({
                emailValid: true
            });
        } else {
            this.setState({
                emailValid: false
            });
        }

        this.setState({
            email: event.target.value
        })
    }

    handleSignUp = () => {
        const headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
          }

        axios.post(this.props.apiurl + '/api/auth/signup', {
            username: this.state.username,
            password: this.state.password,
            email: this.state.email,
            roles: this.state.roles,
            status: this.state.status
        },{headers: headers}).then(res => {
            if (res.status === 200) {
                this.setState({
                    signUpMessage: 'Welcome. Proceed to Login.'
                }); 
                console.log(res); 
            }
        });
    }

    render() {
        let redirect; 
        if (this.state.isLoggedIn === false){
            redirect = <Redirect to="/"></Redirect>
        }

        let emailValid;

        if (this.state.emailValid === true) {
            emailValid = "Email address is valid";
        } else {
            emailValid = "Please enter a valid email address";
        }


        return (
            <div className="container d-flex align-items-center col justify-content-center" style={{ height: '80vh' }}>
                {redirect}
                <div className="card" style={{width: '400px'}}>
                    <img src={logo} style={{ width: '216px', height: 'auto'}}  className="mx-auto d-block" alt="Adapticts.com" />
                    <div className="card-body">

                        <h1 className="h3 mb-3 font-weight-normal">Sign up form</h1>

                        <div className="form-group">
                            <label>Username</label>
                            <input type="text" className="form-control"
                                value={this.state.username}
                                onKeyPress={this.handleUsername}
                                onChange={this.handleUsername}
                            />
                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <input type="password" className="form-control"
                                value={this.state.password}
                                onKeyPress={this.handlePassword}
                                onChange={this.handlePassword}
                            />
                        </div>

                        <div className="form-group">
                            <label>Email</label><small> {emailValid}</small>
                            <input type="email" className="form-control"
                                value={this.state.email}
                                onKeyPress={this.handleEmail}
                                onChange={this.handleEmail}
                            />
                        </div>

                        <button className="btn btn-lg btn-outline-secondary btn-block" onClick={this.handleSignUp}>Sign Up!</button>&nbsp;
                        {this.state.signUpMessage}
                    </div>
                </div>
            </div>
        )
    }

}

export default Signup; 